import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { Table, PageHeader, Modal, FormField, ConfirmDialog } from '../../../components/UI';
import toast from 'react-hot-toast';

const empty = { title:'', message:'', show_on_dashboard:1, is_active:1 };

export default function NoticeMaster() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);

  const load = () => { setLoading(true); api.get('/masters/notices').then(r=>setItems(r.notices||[])).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);

  const openAdd = () => { setForm(empty); setEditing(null); setModal(true); };
  const openEdit = (item) => { setForm({...item}); setEditing(item); setModal(true); };
  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await api.put(`/masters/notices/${editing.id}`, form); toast.success('Updated'); }
      else { await api.post('/masters/notices', form); toast.success('Created'); }
      setModal(false); load();
    } catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  const handleDelete = async () => {
    await api.delete(`/masters/notices/${deleteModal.id}`);
    toast.success('Deleted'); setDeleteModal(null); load();
  };

  const columns = [
    {key:'title',label:'Title'},
    {key:'message',label:'Message',render:r=><span className="text-xs text-gray-500 line-clamp-1">{r.message}</span>},
    {key:'show_on_dashboard',label:'On Dashboard',render:r=><span className={r.show_on_dashboard?'text-green-600':'text-gray-400'}>{r.show_on_dashboard?'Yes':'No'}</span>},
    {key:'is_active',label:'Status',render:r=><span className={r.is_active?'text-green-600':'text-red-500'}>{r.is_active?'Active':'Inactive'}</span>},
    {key:'created_at',label:'Created',render:r=>new Date(r.created_at).toLocaleDateString()},
    {key:'actions',label:'Actions',render:r=>(
      <div className="flex gap-2">
        <button onClick={()=>openEdit(r)} className="text-xs bg-yellow-50 text-yellow-600 border border-yellow-200 px-2 py-1 rounded">✏️</button>
        <button onClick={()=>setDeleteModal(r)} className="text-xs bg-red-50 text-red-600 border border-red-200 px-2 py-1 rounded">🗑️</button>
      </div>
    )}
  ];

  return (
    <div>
      <PageHeader title="Notice Master" subtitle="Manage public notices and announcements"
        actions={<button className="btn-primary" onClick={openAdd}>+ Add Notice</button>} />
      <div className="card overflow-hidden p-0"><Table columns={columns} data={items} loading={loading} /></div>

      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Notice':'Add Notice'} size="lg">
        <form onSubmit={handleSave} className="space-y-4">
          <FormField label="Title" required><input className="form-input" value={form.title} onChange={e=>f('title',e.target.value)} required /></FormField>
          <FormField label="Message" required><textarea className="form-input" rows={5} value={form.message} onChange={e=>f('message',e.target.value)} required /></FormField>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Show on Dashboard">
              <select className="form-select" value={form.show_on_dashboard} onChange={e=>f('show_on_dashboard',e.target.value)}>
                <option value={1}>Yes</option><option value={0}>No</option>
              </select>
            </FormField>
            <FormField label="Status">
              <select className="form-select" value={form.is_active} onChange={e=>f('is_active',e.target.value)}>
                <option value={1}>Active</option><option value={0}>Inactive</option>
              </select>
            </FormField>
          </div>
          <div className="flex gap-3 justify-end">
            <button type="button" className="btn-secondary" onClick={()=>setModal(false)}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>{saving?'Saving...':'Save'}</button>
          </div>
        </form>
      </Modal>

      <ConfirmDialog isOpen={!!deleteModal} onClose={()=>setDeleteModal(null)} onConfirm={handleDelete}
        title="Delete Notice" message={`Delete "${deleteModal?.title}"?`} confirmLabel="Delete" danger />
    </div>
  );
}
